// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1221":"5c7d5b93","3613":"6e5e4919"}[chunkId] + ".chunk.css";
};